'use client'

import { captureException } from '@tucan/utils/error-tracking'
import { useEffect } from 'react'

/**
 * Root error boundary — replaces the pages-router `_error` for failures that
 * happen above the `[lang]` layout. Must render its own <html>/<body> because
 * it substitutes the root layout when it fires.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  )
}
